"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Pipl API service providers used with User ID
var providers = [
    'facebook',
    'linkedin',
    'twitter',
    'myspace',
    'foursquare',
    'ebay',
    'google',
    'pinterest',
    'instagram',
    'lastfm',
    'flickr',
    'youtube',
    'diggtagged',
    'hi5',
    'weeworld',
    'delicious',
    'hyves',
    'deviantart',
    'douban',
    'odnoklassniki',
    'quora',
    'xanga',
    'mylife',
    'gaia',
    'stumbleupon',
    'bebo',
    'livejournal',
    'viadeo',
    'ning',
    'myheritage',
    'qzone',
    'vk',
    'flixster',
    'tumblr',
    'myyearbook',
    'badoo',
    'habbo',
    'xing',
    'sonico',
    'friendster',
    'meetup',
    'goodreads',
    'classmates',
    'renren',
    'cyworld',
    'netlog',
    'soundcloud',
    'yelp',
    'orkut',
    'aboutme',
    'flavorsme',
    'freelancer',
    'gravatar',
    'imgur',
    'github',
    'CPF',
    'medium',
    'NPI',
    'tiktok',
    'strava',
    'academia',
    'VIN',
];
exports.default = providers;
//# sourceMappingURL=serviceProviders.js.map